module.exports = __webpack_public_path__ + "img/two_hand_spiders.df8d3c12.jpg";